// extracted by mini-css-extract-plugin
export var createdDate = "_iu-1";
export var divider = "_iu-2";
export var headerDivider = "_iu-3";
export var messagesCard = "_iu-0";
export var messagesContainer = "_iu-6";
export var messagesContainerWrapper = "_iu-4";
export var showLeftPanelButton = "_iu-8";
export var topButtons = "_iu-7";
export var withPadding = "_iu-5";